import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Slider from 'react-slick'


interface ProfileSectionProps {
    title: string;
    profileList: ProfileProps[];
    buttonText? : string;
    buttonLink? : string;
}

interface ProfileProps {
    imageLink : string;
    blurb : string;
    info : string;
}

const slickMobileSettings = {
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    arrows: false
}

const ProfileSection = (props : ProfileSectionProps) =>{
    return(
        <div className="profile-section">
            <div className="profile-section__title">{props.title}</div>
                <div className="profile-section__profiles">
                    <div className="profile-section__desktop-slider">
                        {
                            props.profileList.map(profile=> {
                                return (
                                    <div className="profile-section__profiles__profile">
                                        <div className="profile-section__profiles__profile__panel">
                                            <div>
                                                <img src={profile.imageLink} className="profile-section__profiles__profile__panel__image"></img>
                                            </div>
                                            <div className="profile-section__profiles__profile__panel__blurb">
                                                {profile.blurb}
                                            </div>
                                        </div>
                                        
                                        <div className="profile-section__profiles__profile__info">
                                            {profile.info}
                                        </div>
                                    </div>
                                    )
                                })
                            }
                    </div>
                    <Slider {...slickMobileSettings} className="profile-section__mobile-slider">
                        {
                            props.profileList.map(profile=> {
                                return (
                                    <div className="profile-section__profiles__profile">
                                        <div className="profile-section__profiles__profile__panel">
                                            <div>
                                                <img src={profile.imageLink} className="profile-section__profiles__profile__panel__image"></img>
                                            </div>
                                            <div className="profile-section__profiles__profile__panel__blurb">
                                                {profile.blurb}
                                            </div>
                                        </div>
                                        <div className="profile-section__profiles__profile__info">
                                            {profile.info}
                                        </div>
                                    </div>
                                    )
                                })
                            }
                    </Slider>
                </div>

                { (props.buttonText && props.buttonLink) &&
                    <a href={props.buttonLink}>
                        <div className="profile-section__read-stories"> {props.buttonText}</div>
                    </a>
                }
        </div>
    )
}





export default function render(){
    const elements = document.getElementsByClassName('obiwan-profile-section')
    Array.prototype.map.call(elements, (element: HTMLElement) => {
        const profileJSON = element.getAttribute('data-profileList');
        const profileList = JSON.parse(profileJSON || '');
        return ReactDOM.render(
            <ProfileSection
                title={element.getAttribute('data-title') || ''}
                profileList={profileList}
                buttonText={element.getAttribute('data-buttonText') || undefined }
                buttonLink={element.getAttribute('data-buttonLink') || undefined }
            />,
            element
        );
    })
}